import { Component, Input } from '@angular/core';
import { ViewCompanyComponent } from 'components/company/viewcompany.component';
import { CompanyDataProviderFactory } from "services/company-data-provider";
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { CompanyResponsibleComponent } from './company-responsible.component';

@Component({
	selector: 'company-dashboard',
	templateUrl: './company-dashboard.component.html',
	providers: [CompanyDataProviderFactory],
	imports: [CompanyResponsibleComponent]
})
@ComponentUrl('company-dashboard')
export class CompanyDashboardComponent {


	private _companyId = '';
	@UrlParam
	@Input()
	set companyId(id: string) {
		this._companyId = id;
		if (id) {
			this.navigation.openNavigationView(this, 'company-related-views', ViewCompanyComponent)
				.then(viewCompany => {
					viewCompany.companyId = id;
					viewCompany.showExtendedCompanyInformation = true;
				});
		}
	}
	get companyId() {
		return this._companyId;
	}

	constructor(private readonly navigation: NavigationService) {
	}
}
